import { c as _c } from "react/compiler-runtime";
interface PdfFileProps {
  fileName: string;
  url: string;
  s3Key: string;
}
export default function PdfFile(t0) {
  const $ = _c(10);
  const {
    fileName,
    url
  } = t0;
  let t1;
  if ($[0] !== fileName) {
    t1 = fileName.replace(".pdf", "");
    $[0] = fileName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const displayName = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-12 h-12 bg-red-600 rounded flex items-center justify-center"><span className="text-white font-bold text-sm">PDF</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== displayName) {
    t3 = <div className="flex items-center space-x-3">{t2}<span className="text-16-tamil-500 text-1B1B1B">{displayName}</span></div>;
    $[3] = displayName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== url) {
    t4 = <a href={url} target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors text-14-tamil-500">பார்க்க</a>;
    $[5] = url;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="border border-gray-300 rounded-lg p-4 bg-gray-50 flex items-center justify-between">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}